<script setup>
import { onMounted, ref, watch } from 'vue';
import MDTextPreview from './MDTextPreview.vue';

const props = defineProps({
    name: String,
    initialContent: {
        type: String,
        default: ''
    }
});

const content = ref(props.initialContent);

onMounted(() => {
    content.value = props.initialContent;
});
</script>

<template>
    <div class="md-text-input">
        <textarea :name="name" v-model="content" class="form-control"></textarea>
        <MDTextPreview :content="content" />
    </div>
</template>

<style scoped>
.md-text-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 16px;
}

.md-text-input textarea,
.md-text-input .md-text-preview {
    flex: 1;
}

.md-text-input textarea {
    width: 100%;
    height: 150px;
}
</style>